import React, { useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useStateContext } from "../contexts/ContextProvider";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { apiAchCheckout, apiCardCheckout } from "../services/apiService";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Checkout = () => {
  const { payment, setNavigateToDashboard } = useStateContext();

  const fetchClientSecret = useCallback(async () => {
    let response;
    setNavigateToDashboard(false);
    if (payment.isCreditCard) {
      console.log("Pay by credit card");
      response = await apiCardCheckout(payment);
    } else {
      console.log("Pay by ACH");
      response = await apiAchCheckout(payment);
    }
    if (response.hasError) {
      console.log(response.error.response.data.error);
    } else {
      return response.data.clientSecret;
    }
  }, []);

  const options = { fetchClientSecret };

  return (
    <div id="checkout" className="mt-32">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default Checkout;
